module.exports = __webpack_public_path__ + "img/4-2.cb5eda19.png";